import ReactDOM from 'react-dom';
import elementResizeDetectorMaker from 'element-resize-detector';
export class ParentNodeResizeDetector {
    erd = null;
    erdElement = null;
    constructor(targetNode, onResize) {
        if (targetNode) {
            this.installElementResizeDetector(targetNode, onResize);
        }
    }
    installElementResizeDetector = (targetNode, onResize) => {
        this.erd = elementResizeDetectorMaker({
            strategy: 'scroll',
        });
        // eslint-disable-next-line react/no-find-dom-node
        const node = ReactDOM.findDOMNode(targetNode);
        const parentNode = node && node.parentElement;
        this.erdElement = parentNode;
        if (parentNode) {
            this.erd.listenTo(parentNode, onResize);
        }
    };
    uninstallElementResizeDetector = () => {
        if (this.erd && this.erdElement) {
            this.erd.uninstall(this.erdElement);
        }
    };
}
